import { render, staticRenderFns } from "./HelpRequest.vue?vue&type=template&id=4be2f494"
import script from "./HelpRequest.vue?vue&type=script&lang=js"
export * from "./HelpRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports